// IMPORT VENDORS
//
import jQuery from 'jquery'
import popper from 'popper.js'
import tippy, {animateFill} from 'tippy.js';
import toastr from 'toastr'



import 'bootstrap'
import 'datatables.net-bs4'
import 'datatables.net-responsive-bs4'
import languageDatatable from './vendor/datatables/lang/fr'
import 'select2'
import languageSelect2 from './vendor/select2/lang/fr'


import {
    startOfYear,
    startOfMonth,
    endOfMonth,
    startOfDay,
    subMonths,
    subDays
} from 'date-fns/esm'
import 'daterangepicker'
import Chartjs from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import Dropzone from 'dropzone/dist/dropzone'
import PerfectScrollbar from 'perfect-scrollbar'
import Swal from 'sweetalert2'
import Glide from '@glidejs/glide'



// IMPORT LOCALS
//
import './defaults'


// GLOBALIZE
//

//variables
window.jQuery = jQuery
window.$ = jQuery

// TOOLTIP TIPPY
window.Popper = popper
window.tippy = tippy
window.animateFill = animateFill

// data-fns function
window.startOfYear = startOfYear
window.startOfMonth = startOfMonth
window.endOfMonth = endOfMonth
window.startOfDay = startOfDay
window.subMonths = subMonths
window.subDays = subDays


window.toastr = toastr
window.Chartjs = Chartjs
window.Dropzone = Dropzone
window.Swal = Swal
window.Glide = Glide
window.languageDatatable = languageDatatable
window.languageSelect2 = languageSelect2
window.axios = require('axios')
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
/**
 * Register CSRF Token
 */
let token = document.head.querySelector('meta[name="csrf-token"]')

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content
} else {
    throw('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token')
}




document.addEventListener("DOMContentLoaded", function (event) {
    // perfect scrollbar on all class .scroller
    $('.scroller').each(function () { const ps = new PerfectScrollbar($(this)[0]); });
    // fondu pour eviter le tilt du dark/whitemode
    $("body").delay(500).animate({ "opacity": "1" }, 300);
    // toaster JS global conf
    toastr.options = window.toastrOptions;
})

// INIT APP
import './app.js'
// import { reduce } from 'highcharts';


// cHART js DEFAULT CONF fort plugin datalabel
Chart.plugins.register(ChartDataLabels);
Chart.defaults.global.plugins.datalabels.display = false;
Chart.helpers.merge(Chart.defaults.global.plugins.datalabels, {
    font: {
        size: 10
    }
});



